const eng = () => {
  return {
    global: {
      next: 'Next',
      requiredField: 'Required field',
      signUp: 'Sign Up',
      finish: 'Finish',
      letsGo: 'Let’s go',
    },
    selectInput: {
      search: 'Search...',
      notFound: 'Not Found',
    },
    signUp: {
      removeSpecialChars: 'Please remove special characters',
      credentialsPage: {
        haveAccount: 'Already have an account?',
        clickHere: 'Click here',
        headline: 'Sign up now for free!',
        passwordDesc: 'Must include at least 5 characters',
        email: 'Email',
        password: 'Create a password',
        telephone: 'Phone Number',
        emailError: {
          exist: 'Username already exists',
          invalid: 'Invalid Email Address',
        },
        passwordError: {
          length: 'Password must be at least 5 characters long',
        },
      },
      businessType: {
        sales: 'sales',
        realEstate: 'Real Estate',
        customerSuccess: 'Customer Success',
        customerService: 'Customer Service',
        education: 'Education',
        media: 'Media',
        insurance: 'Insurance',
        hr: 'HR',
        projectManagement: 'Project Management',
        healthCare: 'Healthcare',
        finance: 'Finance',
        headline: "What's your flavor?",
        secondaryHeadline: 'Choose your business type',
        other: 'Other',
      },
      templateAndCompanySize: {
        headline: "Let's customize your system!",
        industryType: 'What’s your Industry type?',
        companySize: "What's your company's size?",
        weDo: 'Choose template',
        companyName: "What's your company's name?",
      },
      personalDetails: {
        headline: "We'd love to know you better.",
        bySigning: 'By signing up you agree to the',
        and: 'and',
        privacy: 'privacy policy',
        terms: 'terms of service',
        fullName: 'Full Name',
        companyName: 'Company Name',
      },
      creatingScreen: {
        almostThere: 'Almost there!',
        sitTight: "We're setting up your account",
        dashboards: "We're building your dashboards",
        accounts: "We're creating your account",
        workflows: "We're generating your automations",
      },
    },
    positionType: {
      management: 'Management',
      sales: 'Sales',
      service: 'Service',
      marketing: 'Marketing',
      hrAndOp: 'HR & Operations',
      finance: 'Finance',
      other: 'Other',
    },
  };
};

export default eng;
